import React, { Component } from 'react';
import { Info } from 'react-feather';
import { PromptsARB } from './NavPrompts';


class ARB_NavBar extends Component{
    render(){
        return (
            <nav className="navbar navbar-expand-lg navbar-light bg-light py-0" 
            style={{
              paddingTop: "2px", 
              paddingBottom: "2px", 
              alignItems: "right",
              borderBottom: "5px solid #009edb",
              // display: 'block',
              }}>

            {/* <a className="brand-bar-arb ml-2" href="https://un.org/ar">مرحباً بكم في الأمم المتحدة</a> */}


            <button 
              className="navbar-toggler ml-0"
              type="button" 
              data-toggle="collapse" 
              data-target="#navbarTogglerDemo02" 
              aria-controls="navbarTogglerDemo02" 
              aria-expanded="false" 
              aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
            </button>


            <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
			
          {/* <div className='mr-auto'></div> */}
                <ul className="navbar-nav">
                <li className="nav-item">
                    <a className="nav-link small" href="/ARB">العربية</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link small" href="/CHN">中文</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link small" href="/ENG">English</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link small" href="/FRE">Français</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link small" href="/RUS">Русский</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link small" href="/ESP">Español</a>
                </li>
                </ul>
  <a className='navbar-brand text-secondary nav-link pt-1 pb-1 pl-3 text-right' dir='rtl' data-toggle='modal' data-target='#aboutUs'>
    {/* <HelpCircle width='15px' height='15px' strokeWidth='2' enableBackground='true' /> */}
    <Info width='15px' height='15px' strokeWidth='2' enableBackground='true' />
  </a>
  <div className='modal fade' id='aboutUs' tabIndex='-1'>
    <div className='modal-dialog aboutUsModal text-right'>




      <div      //model content start
                style={{
                      borderLeft: "5px solid #009edb",
                      width: "75%",
                      margin: "0 auto",
                  }}
      
      className='modal-content'>

        <div 
        
        className='modal-header-arb aboutUsHeaderArb pt-0 pb-2 pr-2 pt-2' dir='rtl'>
          <button
            style={{ 
              marginRight: '5px',
              alignContent: 'right',
              display: 'block', 
              paddingTop: '0px',
              paddingBottom: '0px',
            }}
           type='button' className='close close-popup text-right' dir='rtl' data-dismiss='modal' aria-label='Close'>
            <span aria-hidden='true'>&times;</span>
          </button>
          
          <h6 
            style={{
              maxWidth: '180px',
              display: 'block', 
              color: "#404040",
              backgroundColor: "#ffffff",
              borderBottom: "none",
              marginRight: '70px',
              borderBottom: "3px solid #009edb",
              fontFamily: "'Roboto Condensed', Arial, sans-serif",
              fontSize: '26px',
              letterSpacing: '0px',
              opacity: 1,
              fontWeight: 700}}
          
          className='modal-title text-right mt-2 text-right' id='aboutUs' dir='rtl'>
            {PromptsARB.aboutUsTitle}
          </h6>
          {/* <button
            style={{ 
              paddingTop: '0px',
              paddingBottom: '0px',
            }}
           type='button' className='close text-right' dir='rtl' data-dismiss='modal' aria-label='Close'>
            <span aria-hidden='true'>&times;</span>
          </button> */}
        </div>


        {/* <div className='modal-body'>
          <p className='text-secondary text-right' dir='rtl'>
            {PromptsARB.aboutUs1}
            <strong>
              <u>{PromptsARB.aboutUs2}</u>
            </strong>
            {PromptsARB.aboutUs3}
          </p>
          <p className='text-secondary text-right' dir='rtl'>{PromptsARB.aboutUs4}</p>
          <p className='text-secondary text-right' dir='rtl'>{PromptsARB.aboutUs5}</p>
          <p className='text-secondary text-right' dir='rtl'>{PromptsARB.aboutUs6}</p>
        </div> */}

          <div
                                        style={{
                                          // width: '700px',
                                          // height: 'px', 
                                          // background: '#F5f5f5',
                                  
                                          display: 'flex',
                                          alignItems: 'stretch',
                                          //padding: '0 0 0 12px',  // space for vertical line
                                          boxSizing: 'border-box',
                                          overflowY: 'auto',        // vertical scroll if content exceeds height
                                          // marginTop: '20px',
                                          marginLeft: '40px',
                                          marginRight: '40px',
                                          marginBottom: '20px',
                            
                                        }}
                                        >
                                        {/* Vertical line */}
                                        {/* <div
                                          style={{
                                            width: '4px',
                                            backgroundColor: '#009EDB',
                                            marginRight: '12px',
                                            flexShrink: 0,
                                          }}
                                        ></div> */}
                          
                                        {/* Text content */}
                                        <div style={{ display: 'flex', flexDirection: 'column', flex: 1  }}>
                                          {/* Caption text */}
                                          <p
                                            dir='rtl'
                                            className='my-0 map-caption text-right'
                                            style={{
                                              fontSize: '16px',
                                              marginRight: '40px',
                                              marginLeft: '5px',
                                              // paddingTop: '20px',
                                              // paddingRight: '20px',
                                              paddingBottom: '20px',
                                              lineHeight: '24px', 
                                              // fontFamily: "'Roboto'",
                                              letterSpacing: '0px',
                                              fontWeight: 400,
                                              opacity: 1,
                                              //font: 'normal normal normal 8px/12px Roboto',
                                              color: '#404040',//'#8c8c8c',
                                              // color: '#cdcdcd',
                                              // letterSpacing: '0.5px',
                                              // lineHeight: '1.2',
                                              
                                            }}
                                            >
                                            {/* {CaptionENG} */}
                                            {PromptsARB.aboutUs1}
                                            <strong>
                                            {PromptsARB.aboutUs2}
                                            </strong>
                                            {PromptsARB.aboutUs3}
                                          </p>
                                          {/* Caption text */}
                                          <p
                                            dir='rtl'
                                            className='my-0 map-caption text-right'
                                            style={{
                                              fontSize: '16px',
                                              marginRight: '40px',
                                              marginLeft: '5px',
                                              // paddingTop: '20px',
                                              // paddingRight: '20px',
                                              paddingBottom: '20px',
                                              lineHeight: '24px', 
                                              fontFamily: "'Roboto'",
                                              letterSpacing: '0px',
                                              fontWeight: 400,
                                              opacity: 1,
                                              //font: 'normal normal normal 8px/12px Roboto',
                                              color: '#404040',//'#8c8c8c',
                                              // color: '#cdcdcd',
                                              // letterSpacing: '0.5px',
                                              // lineHeight: '1.2',
                                            }}
                                            >
                                            {/* {CaptionENG} */}
                                            {PromptsARB.aboutUs4}
                                          </p>
          
          
                                          <p
                                            dir='rtl'
                                            className='my-0 map-caption text-right'
                                            style={{
                                              fontSize: '16px',
                                              marginRight: '40px',
                                              marginLeft: '5px',
                                              // paddingTop: '20px',
                                              // paddingRight: '20px',
                                              paddingBottom: '20px',
                                              lineHeight: '24px', 
                                              fontFamily: "'Roboto'",
                                              letterSpacing: '0px',
                                              fontWeight: 400,
                                              opacity: 1,
                                              //font: 'normal normal normal 8px/12px Roboto',
                                              color: '#404040',//'#8c8c8c',
                                              // color: '#cdcdcd',
                                              // letterSpacing: '0.5px',
                                              // lineHeight: '1.2',
                                            }}
                                            >
                                            {/* {CaptionENG} */}
                                            {PromptsARB.aboutUs6}
                                          </p>
                          
                                        </div>
                                      </div>


      </div>  {/* Model content end */}
    </div>
  </div>
</div>
      <a className="brand-bar-arb pt-5 pb-10 nav-link ml-5 d-none d-lg-block" href="https://un.org/ar">مرحباً بكم في الأمم المتحدة</a>

            </nav>
        )
    }

};

export default ARB_NavBar;